import store from "@/store";
import router from "@/router";

export default {
  created: function() {
    if (store.state.isAuth === true) router.push({ name: "dashboard" });
  }
};
